<div
  class="wrapper p-field"
  [style.fontSize]="fontSize"
  [ngClass]="wrapperNgClasses"
>
  <label *ngIf="label" class="label label__static">{{ label }}</label>

  <div class="input option-row">
    <button
      type="button"
      class="checkbox-wrapper"
      *ngFor="let option of checkboxOptions"
      [class.disabled]="isGroupDisabled"
      [disabled]="isGroupDisabled"
      (click)="select(option)"
    >
      <span class="checkbox">
        <img
          *ngIf="isSelected(option)"
          class="checkbox__img"
          src="assets/svg/checkboxSelect.svg"
          alt=""
        />
      </span>
      <span class="checkbox-label">{{ option.label }}</span>
    </button>
  </div>
</div>
